/* WONDER, front-end behaviors (vanilla, no deps) */
(function () {
  var root = document.documentElement;
  root.classList.add('js');
  root.classList.remove('no-js');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) root.classList.add('reduced');

  /* ---------- mobile nav ---------- */
  document.querySelectorAll('[data-nav]').forEach(function (nav) {
    var toggle = nav.querySelector('.nav-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
      document.body.style.overflow = !open ? 'hidden' : '';
    });
    nav.querySelectorAll('.nav-links a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.setAttribute('data-open', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  });

  /* ---------- staggered reveals (fallback when no scroll-timeline) ---------- */
  var supportsTimeline = CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  var revealEls = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || reduced || supportsTimeline) {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  } else {
    var pending = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target; io.unobserve(el);
        var parent = el.parentElement;
        var count = pending.get(parent) || 0;
        pending.set(parent, count + 1);
        setTimeout(function () { el.classList.add('in'); }, count * 180);
        setTimeout(function () { pending.set(parent, 0); }, 1400);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -80px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ---------- kernel parallax ---------- */
  (function () {
    var decals = Array.prototype.slice.call(document.querySelectorAll('.kdecal'));
    if (!decals.length || reduced) return;
    function measure() {
      decals.forEach(function (d) {
        var r = d.getBoundingClientRect();
        d._mid = r.top + window.pageYOffset + d.offsetHeight / 2;
        d._speed = parseFloat(d.getAttribute('data-speed') || '0.1');
        d._rot = parseFloat(d.getAttribute('data-rot') || '0');
      });
    }
    function parallax() {
      var y = window.pageYOffset, vh = window.innerHeight;
      decals.forEach(function (d) {
        var ty = ((y + vh / 2) - d._mid) * d._speed;
        d.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0) rotate(' + d._rot + 'deg)';
      });
    }
    var raf = null;
    measure(); parallax();
    window.addEventListener('scroll', function () {
      if (raf) return; raf = requestAnimationFrame(function () { raf = null; parallax(); });
    }, { passive: true });
    window.addEventListener('resize', function () { measure(); parallax(); });
  })();


  /* ---------- manifesto word-scrub ---------- */
  (function () {
    var manifesto = document.querySelector('.manifesto.is-scrub');
    var inner = manifesto && manifesto.querySelector('.manifesto-inner');
    if (!manifesto || !inner) return;

    var ACC = { pink:{wonder:1,feel:1,feeling:1}, blue:{corn:1,grows:1,popcorn:1,bag:1}, yellow:{attention:1,point:1} };
    function accentClass(part){
      var k = part.toLowerCase().replace(/[^a-zåæø]/g,'');
      if (ACC.pink[k]) return ' acc-pink';
      if (ACC.blue[k]) return ' acc-blue';
      if (ACC.yellow[k]) return ' acc-yellow';
      return '';
    }
    function splitWords(el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (node) {
        if (node.nodeType === 3) {
          var frag = document.createDocumentFragment();
          node.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var s = document.createElement('span'); s.className = 'w' + accentClass(part); s.textContent = part;
            frag.appendChild(s);
          });
          el.replaceChild(frag, node);
        } else if (node.nodeType === 1) { splitWords(node); }
      });
    }
    inner.querySelectorAll('p').forEach(splitWords);
    var words = inner.querySelectorAll('.w');
    if (reduced) { words.forEach(function (w) { w.classList.add('lit'); }); return; }

    var media = Array.prototype.slice.call(manifesto.querySelectorAll('.mf-shot'));
    var shown = -1;
    var litCount = -1;
    function update() {
      var rect = manifesto.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
      var n = Math.round(Math.min(1, progress * 1.18) * words.length);
      if (n === litCount) return;
      litCount = n;
      for (var i = 0; i < words.length; i++) words[i].classList.toggle('lit', i < n);
      if (media.length) {
        var k = Math.min(media.length - 1, Math.floor(progress * media.length));
        if (k !== shown) {
          shown = k;
          for (var m = 0; m < media.length; m++) media[m].classList.toggle('on', m === k);
        }
      }
    }
    var raf = null;
    function onScroll() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; update(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  })();

  /* ---------- cursor parallax (curious / alive) ---------- */
  (function () {
    if (reduced || !window.matchMedia || !matchMedia('(pointer:fine)').matches) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!els.length) return;
    var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
    function loop() {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      els.forEach(function (el) {
        var s = parseFloat(el.getAttribute('data-parallax')) || 16;
        el.style.translate = (cx * s).toFixed(1) + 'px ' + (cy * s).toFixed(1) + 'px';
      });
      if (Math.abs(tx - cx) > 0.0005 || Math.abs(ty - cy) > 0.0005) raf = requestAnimationFrame(loop);
      else raf = null;
    }
    window.addEventListener('mousemove', function (e) {
      tx = e.clientX / window.innerWidth - 0.5;
      ty = e.clientY / window.innerHeight - 0.5;
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
  })();

  /* ---------- fun fact: rotate through the facts ---------- */
  document.querySelectorAll('[data-funfact]').forEach(function (box) {
    var slides = box.querySelectorAll('.ff-slide');
    if (slides.length < 2) return;
    var secs = parseFloat(box.getAttribute('data-rotate'));
    if (!secs) return;                       /* rotation switched off in the editor */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, timer = null;
    function show(n) {
      slides[i].classList.remove('is-on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on');
    }
    function start() { timer = setInterval(function () { show(i + 1); }, secs * 1000); }
    function stop() { clearInterval(timer); timer = null; }
    start();
    /* pause while the tab is hidden so it does not churn in the background */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (!timer) { start(); }
    });
  });

  /* ---------- PDP: packs, gallery, sticky add-to-cart ---------- */
  document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
    var form = pdp.querySelector('.pdp-form');
    var qtyInput = pdp.querySelector('input[name="quantity"]');
    function totals() { return document.querySelectorAll('[data-cart-total],[data-cart-total-mirror]'); }

    /* size buttons share .pdp-pack styling, so packs must exclude them or a size
       click would be treated as a quantity change */
    var packs = pdp.querySelectorAll('.pdp-pack:not(.pdp-size)');
    var sizes = pdp.querySelectorAll('.pdp-size');
    var idInput = pdp.querySelector('[data-variant-id]');
    var mixPack = pdp.querySelector('.pdp-pack-mix');
    var mixToggle = pdp.querySelector('[data-mix-toggle]');

    function activePack() { return pdp.querySelector('.pdp-pack:not(.pdp-size)[aria-pressed="true"]'); }
    function activeSize() { return pdp.querySelector('.pdp-size[aria-pressed="true"]'); }

    /* single source of truth for the posted variant, the quantity and the displayed
       price. Totals are Liquid-formatted strings on the size buttons, so currency
       formatting never has to be reimplemented here. */
    function sync() {
      var pack = activePack();
      var qty = pack ? (pack.getAttribute('data-qty') || '1') : '1';
      if (qtyInput && pack) qtyInput.value = qty;

      var size = activeSize();
      if (size) {
        /* the checkbox is not a size: it swaps to the half-and-half twin of
           whichever size is selected, falling back when that size has none */
        var wantMix = !!(mixToggle && mixToggle.checked);
        var mixId = size.getAttribute('data-variant-mix');
        if (idInput) idInput.value = (wantMix && mixId) ? mixId : size.getAttribute('data-variant');
        /* keep the mixed pack on the chosen size rather than the first variant */
        if (mixPack && size.getAttribute('data-mix')) {
          mixPack.setAttribute('data-mix', size.getAttribute('data-mix'));
        }
        var mixT = size.getAttribute('data-t1-mix');
        var t = (wantMix && mixT) ? mixT : (size.getAttribute('data-t' + qty) || size.getAttribute('data-t1'));
        if (t) totals().forEach(function (el) { el.textContent = t; });
        return;
      }
      var total = pack && pack.getAttribute('data-total');
      if (total) totals().forEach(function (el) { el.textContent = total; });
    }

    sync();

    packs.forEach(function (b) {
      b.addEventListener('click', function () {
        packs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        sync();
      });
    });

    if (mixToggle) mixToggle.addEventListener('change', sync);

    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        sizes.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        sync();
      });
    });

    var main = pdp.querySelector('.pp-main');
    pdp.querySelectorAll('.pp-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        pdp.querySelectorAll('.pp-thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (main && t.getAttribute('data-src')) main.src = t.getAttribute('data-src');
      });
    });

    /* "12 mixed" is not a quantity: it adds 6 of each flavour, so it bypasses
       the normal form post and builds a two-line cart payload instead. */
    var form = pdp.querySelector('.pdp-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var active = pdp.querySelector('.pdp-pack[aria-pressed="true"]');
        var mix = active && active.getAttribute('data-mix');
        if (!mix) return;
        e.preventDefault();
        var items = mix.split(',').map(function (pair) {
          var kv = pair.split(':');
          return { id: Number(kv[0]), quantity: Number(kv[1]) };
        }).filter(function (it) { return it.id && it.quantity; });
        if (!items.length) { form.submit(); return; }
        var btn = form.querySelector('.pdp-add');
        if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
          form.submit();
        });
      });
    }

    var addBtn = pdp.querySelector('.pdp-add');
    var sticky = document.querySelector('[data-pdp-sticky]');
    if (addBtn && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(addBtn);
      var sAdd = sticky.querySelector('[data-sticky-add]');
      if (sAdd && form) sAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  });
})();
